import "./location.css";
/* import { MapContainer } from "./map "; */
function Location() {
  return (
    <div >
      <div className="advantageTitle">Location </div>
      <div className="location">
        
       {/* <MapContainer/> */}
      <div className="newLocation">
      <iframe className="newMap"  src="https://maps.google.com/maps?q=%2010%20Bis%20Rue%20d'Algerie%201001%20Tunis,%20Tunisie&t=&z=15&ie=UTF8&iwloc=&output=embed" frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0"></iframe>
      </div>
      <div className="textLocation">
          ✔️ 5 Place Mongi Bali, Barcelone Tunis, Tunisie
          <br />
          ✔️ Contact@makerskills.tn
          <br />
          ✔️ +216 25 801 660 <br />
          ✔️ https://makerskills.tn/ <br />

          </div>
      </div>
    </div>
  );
}
export default Location;
